import { useEffect, useState } from "react";

import "../css/PopupPrintingSale.css";

import ButtonIconH from "../../components/ButtonIconH";
import CheckBox from "../../components/CheckBox";
import Dropdown from "../../components/Dropdown";
import LoadingScreen from "../../components/LoadingScreen";
import { printInvoice } from "./PopupInvoicePrinting";

const DOCUMENT_TYPE_IS_COMPLETE = {
  "imp-ticket": false,
  "imp-factura-canje": true,
  "imp-ticket-abono": false,
  "imp-ticket-rect": false,
  "imp-factura": true,
  "imp-factura-abono": true,
  "imp-factura-rect": true,
};

const isCompleteDocument = (documentId) =>
  DOCUMENT_TYPE_IS_COMPLETE[documentId] ?? false;

export default ({
  show,
  idVenta,
  documentOptions = [],
  onClose,
  onSent,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [printObservations, setPrintObservations] = useState(false);
  const [printPayments, setPrintPayments] = useState(false);
  const [sending, setSending] = useState(false);
  const isComplete = isCompleteDocument(selectedDocument?.id);

  const selectDocument = (item) => {
    setSelectedDocument(item);
    if (!isCompleteDocument(item?.id)) {
      setPrintObservations(false);
      setPrintPayments(false);
    }
  };

  useEffect(() => {
    if (show) {
      selectDocument(documentOptions[documentOptions.length - 1] ?? null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const sendEmail = async () => {
    if (!selectedDocument) return;

    setSending(true);
    const response = await printInvoice({
      idVenta,
      invoiceType: selectedDocument.id,
      printObservations,
      printPayments,
      createPopupQuestion,
      removePopupQuestion,
    });
    setSending(false);

    if (!response) return;

    onClose();
    onSent({
      titulo: response.nombreFichero,
      fichero: response.fichero,
    });
  };

  return (
    show && (
      <div className="popup-container popup-normal popup-printing-sale">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Imprimir venta</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onClose}
            />
          </div>
          <div className="popup-body">
            {sending && <LoadingScreen message="" />}
            <div className="popup-row">
              <div className="label">Documento</div>
              <Dropdown
                id="printing-sale-document"
                disabled={false}
                optionList={documentOptions.map((item) => ({
                  ...item,
                  text: (item.text ?? "").toUpperCase(),
                }))}
                size={2}
                op={selectedDocument ? selectedDocument.id : null}
                onChange={selectDocument}
              />
            </div>
            <div className="popup-row popup-row-checks">
              <div
                className={`data-field ${isComplete ? "c-pointer" : ""}`}
                onClick={() =>
                  isComplete && setPrintObservations((prev) => !prev)
                }
              >
                <CheckBox
                  active={printObservations}
                  disabled={!isComplete}
                  onClick={() => {}}
                />
                <span className="label">Imprimir observaciones</span>
              </div>
              <div
                className={`data-field ${isComplete ? "c-pointer" : ""}`}
                onClick={() => isComplete && setPrintPayments((prev) => !prev)}
              >
                <CheckBox
                  active={printPayments}
                  disabled={!isComplete}
                  onClick={() => {}}
                />
                <span className="label">Imprimir pagos</span>
              </div>
            </div>
          </div>
          <div className="popup-footer">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Enviar email"
                disabled={sending}
                onClick={sendEmail}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
